import React, { useEffect } from "react";
import KWH18MSC121_A from "../3d/new/KWH-18M-SC121_A";
import KWH18MSC121_B from "../3d/new/KWH-18M-SC121_B";
import KWH18MSC122 from "../3d/new/KWH-18M-SC122";
import KWH18MSC123 from "../3d/new/KWH-18M-SC123";
import CAPRIATA from "../3d/new/CAPRIATA";

const Component = (props) => {
  const { file, onXUpdate, camPosition } = props;
  useEffect(() => {
    onXUpdate(camPosition);
  }, [file]);

  switch (file) {
    case "KWH-18M-SC121_A":
      return (
        <KWH18MSC121_A
          {...props}
          //onUpdate={() => onUpdate(camPosition)}
        ></KWH18MSC121_A>
      );
      break;
    case "KWH-18M-SC121_B":
      return (
        <KWH18MSC121_B
          {...props}
          //onUpdate={() => onUpdate(camPosition)}
        ></KWH18MSC121_B>
      );
      break;
    case "KWH-18M-SC122":
      return (
        <KWH18MSC122
          {...props}
          //onUpdate={() => onUpdate(camPosition)}
        ></KWH18MSC122>
      );
      break;
    case "KWH-18M-SC123":
      return (
        <KWH18MSC123
          {...props}
          //onUpdate={() => onUpdate(camPosition)}
        ></KWH18MSC123>
      );
      break;
    default:
      return (
        <KWH18MSC121_A
          {...props}
          //onUpdate={() => onUpdate(camPosition)}
        ></KWH18MSC121_A>
      );
      break;
  }
};
export default function Central(props) {
  const { final, update } = props;

  return (
    <>
      {final.items &&
        Array(final.items)
          .fill()
          .map((i, k) => {
            const isEven = (k + 1) % 2;
            const position =
              isEven === 1
                ? [6 * (parseInt(k / 2) + 1), 0, 0]
                : [18 + 6 * (parseInt(k / 2) - 1), 0, -18];
            const rotation = isEven === 1 ? [0, 0, 0] : [0, Math.PI, 0];
            const camPosition =
              isEven === 1
                ? {
                    x: 0,
                    y: 10 * (final?.items?.length || 1),
                    z: 30 * (final?.items?.length || 1),
                  }
                : {
                    x: 0,
                    y: 10 * (final?.items?.length || 1),
                    z: -30 * (final?.items?.length || 1),
                  };
            return (
              <>
                <Component
                  key={k + "" + position}
                  position={position}
                  rotation={rotation}
                  wallcolor={final.wallcolorhex}
                  tinsmithcolorhex={final.tinsmithcolorhex}
                  covercolor={final.covercolorhex}
                  onXUpdate={update}
                  file={final?.central?.data?.[k]?.file}
                  final={final}
                  camPosition={camPosition}
                />
                {!isEven && (
                  <CAPRIATA
                    position={[6 * (parseInt(k / 2) + 1), 0, 0]}
                  ></CAPRIATA>
                )}
              </>
            );
          })}
    </>
  );
}
